// Engins à AFFICHER / IMPRIMER dans l'onglet Attestations d'un contrat.
//
// Pour un avenant d'INCORPORATION (code "IN"), la version de contrat porte TOUTE la
// flotte dans `engins` (anciens + nouveaux) mais uniquement les nouveaux dans
// `incorpores`. À l'impression des attestations d'une incorporation, on ne doit
// traiter QUE les engins incorporés — pas relister toute la flotte.
//
// Repli sur `engins` pour les autres avenants (ou si `incorpores` est absent) → aucune
// régression. Source UNIQUE : utilisée à la fois pour l'affichage (mapping + refs
// indexés sur l'ordre d'affichage) ET pour l'attribution/impression (findIndex par
// codeId). Les deux DOIVENT itérer la même liste, sinon les index/refs se désynchronisent.
export const enginsPourAttestation = (contrat) =>
    (contrat?.avenant?.code === "IN"
        && Array.isArray(contrat?.incorpores)
        && contrat.incorpores.length > 0)
        ? contrat.incorpores
        : (contrat?.engins || []);
